var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon, { defaultProps as iconDefaultProps } from '../Icon/Icon';
import ButtonStyle, { ArrowRight, IconLeft, IconRight, } from './ButtonStyle';
const Button = React.forwardRef((_a, ref) => {
    var { children, iconLeft, iconRight, icon, iconSize, taskflow } = _a, otherProps = __rest(_a, ["children", "iconLeft", "iconRight", "icon", "iconSize", "taskflow"]);
    const iconProps = {
        size: iconSize || iconDefaultProps.size,
    };
    return (React.createElement(ButtonStyle, Object.assign({ ref: ref }, otherProps, { taskflow: taskflow }),
        iconLeft && React.createElement(IconLeft, Object.assign({}, iconProps), iconLeft),
        icon ? React.createElement(Icon, Object.assign({}, iconProps), icon) : children,
        iconRight && React.createElement(IconRight, Object.assign({}, iconProps), iconRight),
        taskflow && React.createElement(ArrowRight, null)));
});
export default Button;
//# sourceMappingURL=Button.js.map